/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, convertHexToRGB, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED NAME : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	embedname: {
		background: 'rgba(242, 244, 248, 0.5)',
		borderRadius: pxToEm(2),
		maxWidth: '50vw',
		display: 'inline-flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		alignItems: 'flex-end',

		'& .name': {
			maxWidth: '75%',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			color: theme.color.primary.medium.swatch,
			marginRight: pxToEm(5)
			
		},
		'& .site': {
			marginLeft: pxToEm(5),
			marginRight: pxToEm(5)
		},
	
		padding: pxToEm(5),
		extend: theme.typography.size.xsmall,
		cursor: 'pointer',
		textAlign: 'center',
		// margin: replacePXinStringWithEM(`0 auto 15px`),
		color: convertHexToRGB(theme.color.supporting.medium.swatch, 50),
	
		'& .icon': {
			color: theme.color.primary.medium.swatch,
		}
	},
	[mediaQuery.customizeInContentThin]: {
		embedname: {
			maxWidth: '30vw'
		}
	},
	[mediaQuery.customizeThinnest]: {
		embedname: {
			maxWidth: '70vw'
		}
	},
});
